module.exports = "https://deal-img.imgix.net/consumer/modern/logo.ea14b28d.jpg";